import { Grid, Typography } from "@mui/material";
import GlassCard from "../../components/dashboard/GlassCard";
import IncidentTimeline from "../../components/enterprise/IncidentTimeline";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { platformMockService } from "../../services/mock/platformMockService";
import { intelligenceTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const PersonJourneyPage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  return (
    <ModuleLayout title={t("platform.pages.personJourney.title")} subtitle={t("platform.pages.personJourney.subtitle")} breadcrumbs={[t("platform.nav.intelligence"), t("platform.tabs.journeys")]} tabs={intelligenceTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <Grid container spacing={2.5}>
          <Grid item xs={12} lg={5}>
            <GlassCard hover={false}>
              <Typography variant="h5">{t("platform.pages.personJourney.person")}</Typography>
              <Typography variant="body2" color="text.secondary">{t("platform.pages.personJourney.demoTrajectory")}</Typography>
            </GlassCard>
          </Grid>
          <Grid item xs={12} lg={7}>
            <GlassCard hover={false}><IncidentTimeline items={platformMockService.getIncidentTimeline()} /></GlassCard>
          </Grid>
        </Grid>
      ) : (
        <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledAnalyticsDescription")} />
      )}
    </ModuleLayout>
  );
};

export default PersonJourneyPage;
